import { useEffect, useState } from 'react';
import { isClient } from 'hooks/use-url-params-utils';

/**
 * Custom hook for managing search state and operations
 * Encapsulates all search-related state and handlers to reduce prop drilling
 */
const useSearchState = () => {
    const [itemListSearch, setItemListSearch] = useState([]);
    const [currentPageSearch, setCurrentPageSearch] = useState(null);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [errorSearch, setErrorSearch] = useState(false);
    const [showMoreButtonSearch, setShowMoreButtonSearch] = useState(true);
    const [activeSearch, setActiveSearch] = useState(false);
    const [searchTerm, setSearchTerm] = useState(null);

    useEffect(() => {
        if (!isClient()) {
            return;
        }

        if (activeSearch) {
            setCurrentPageSearch(1);
        }
    }, [activeSearch]);

    const resetSearchResults = () => {
        setItemListSearch([]);
        setCurrentPageSearch(1);
        setErrorSearch(false);
        setShowMoreButtonSearch(true);
    };

    const appendSearchResults = (newResults) => {
        setItemListSearch((prevList) => [...prevList, ...newResults]);
    };

    const searchHandlers = {
        setData: setItemListSearch,
        setShowMoreButton: setShowMoreButtonSearch,
        setLoading: setLoadingSearch,
        setError: setErrorSearch,
        setActiveSearch,
        setCurrentPageSearch,
        setSearchTerm,
        resetSearchResults,
        appendSearchResults
    };

    const searchState = {
        itemListSearch,
        currentPageSearch,
        loadingSearch,
        errorSearch,
        showMoreButtonSearch,
        activeSearch,
        searchTerm
    };

    return {
        ...searchState,
        ...searchHandlers
    };
};

export default useSearchState;
